module.exports = __webpack_public_path__ + "static/media/21-9.93a35234.mp3";